import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetSetores } from '@/modules/structure/setor/setor.service';
import { Link } from 'react-router-dom';
import { ReadSetorDto } from '@/api.types';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function SetorIndex() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadSetorDto[], number]>();

  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    const termo = tableState.filter.trim();
    GetSetores(
      {
        skip: (tableState.currentPage - 1) * tableState.pageSize,
        take: tableState.pageSize,
        comPredio: true,
        comPai: true,
        where: termo || undefined,
        orderBy: tableState.sortConfig.direction,
        orderField: tableState.sortConfig.key,
      })
      .then((result) => {
        if (result) {
          setRegistros([result.objects, result.count]);
        }
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({
      primary: { label: 'Cadastrar', href: Links.Setor_Criar, onClick: () => { } },
      secondary: {
        label: 'Colaboradores',
        href: Links.Setor_Relatorio_Colaboradores,
        onClick: () => { },
      },
    });
    return () => setActions({});
  }, [setActions]);

  const colunas: Column<ReadSetorDto>[] = [
    { key: 'sigla', header: 'Sigla/Número' },
    { key: 'nome', header: 'Nome' },
    { key: 'capacidade', header: 'Capacidade' },
    {
      key: 'pai',
      header: 'Setor pai',
      render: (row) => <>{row.pai?.nome || '-'}</>,
    },
    {
      key: 'predio',
      header: 'Unidade',
      render: (row) => <>{row.predio?.nome || '-'}</>,
    },
    {
      key: 'acoes',
      header: 'Ações',
      render: (row) => (
        <Link className="link-secondary" to={Links.Setor_Editar + '/' + row.id}>
          Editar
        </Link>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Setores</h3>
          <span className="blockquote-footer pb-4 text-end">
            Salas e setores das unidades.
          </span>
        </div>
        <hr className="pb-4" />

        {registros && (
          <DataTable
            columns={colunas}
            data={registros[0]}
            initialSortKey="nome"
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        )}
      </div>
    </>
  );
}


